import script from "./ReviewEditDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewEditDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ReviewEditDialog.vue?vue&type=style&index=0&id=967a9c74&lang=scss"

const __exports__ = script;

export default __exports__